import React from 'react'
import PageEnhance from '../../../vendor/PageEnhance'
import BasePage from '@base/BasePage'
import { Iconfont, IconCodeEmum } from '../../../components'
import CSS from './index.module.css'
import { Bridge } from '@iskytrip/sdk'

@PageEnhance
class PlayVideo extends BasePage {
	constructor(props) {
		super(props)
		this._hideLoadingPage = true
		this.video = React.createRef()
		this.state = {
			signalBarHeight: 20,
		}
	}

	pageAppear() {
		const self = this
		Bridge.appGetSignalBarHeight((height) => {
			self.setState(
				{
					signalBarHeight: height,
				},
				function() {
					console.log(height)
				},
			)
		})
		setTimeout(function() {
			self.video.current.play()
		}, 500)
	}

	backAction() {
		if (this.props.showType === 'pop') {
			this.props.close()
		} else {
			this.back()
		}
	}

	render() {
		return (
			<div>
				<Iconfont
					font={IconCodeEmum.CLOSE}
					style={{
						fontSize: '0.6rem',
						color: 'white',
						position: 'fixed',
						left: '.4rem',
						top: `${this.state.signalBarHeight}px`,
						zIndex: '99',
					}}
					onPress={this.backAction.bind(this)}
				/>
				<video
					className={CSS.video}
					controls
					autoPlay
					x5-playsinline='true'
					playsinline='true'
					webkit-playsinline='true'
					controlsList='nodownload nofullscreen noremoteplayback'
					ref={this.video}
				>
					<source
						// src='https://static.iskytrip.com/activity/springfestival_20200115/image/video.mp4'
						src={this.props.url}
						type='video/mp4'
					/>
					您的浏览器不支持HTML5 video标签。
				</video>
			</div>
		)
	}
}

export default PlayVideo
